// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumbs_container_1qbmA"};